export default __webpack_public_path__ + "static/media/blueM.b8bd4845.svg";